export enum BaseballStatId {
  Hits = 87,
  Challenges = 109,
  ChallengesCorrect = 110,
  Double = 142,
  Triple = 143,
  HomeRunHits = 144,
  Strikes = 145,
  Balls = 146,
  Outs = 147,
  Strikeouts = 148,
  CaughtStealing = 150,
  StolenBases = 151,
  /** Grandslams */
  GSH = 152,
  Errors = 153,
  BaseOnBalls = 165,
  Single = 166,
  StrikesTemporary = 404,
  OutsTemporary = 405,
  BallsTemporary = 406,
  FirstBase = 407,
  SecondBase = 408,
  ThirdBase = 409,
  Runs = 569,
  Skin = 718,
  Pitches = 769,
  /** At Bats */
  AB = 1218,
  /** Runs Batted In */
  RBI = 1219,
  /** Left On Balls */
  LOB = 1217,
  /** Earned Run Average */
  ERA = 1221,
  /** Innings Pitched */
  IP = 1222,
  /** Hits allowed by a pitcher */
  HAllowed = 1223,
  /** Runs allowed by a pitcher */
  RAllowed = 1224,
  /** Earned Runs allowed by a pitcher */
  ERAllowed = 1225,
  /** Pitcher Strikeouts */
  PitcherSO = 1226,
  /** Base on balls allowed by a pitcher */
  BBAllowed = 1227,
  /** Home Runs allowed by a pitcher */
  HRAllowed = 1228,
  Saves = 1230,
  Win = 1231,
  Loss = 1232,
  /** Batting Average */
  AVG = 1237,
  WillNotPlay = 1239,
  /** Hit by pitch */
  HBP = 1376,
  WildPitch = 1377,
  Groundouts = 1378,
  Flyouts = 1379,
  SacrificeFly = 1380,
  PitcherOuts = 1396,
  BackToBackHits = 1465,
}
